<template>
    <div class="guide">
        <div class="guide_header" v-if="headerShow ===1">
            <p  @click="btnClick">
                <img src="../../../../assets/complaint/guide.png" alt="">
            </p>
            <p>导游绑定列表</p>
            <p @click="showSerch">
                <img src="../../../../assets/image/search.png" alt="">
            </p>
        </div>
        <div class="search" v-if="headerShow1 === 2">
            <img src="../../../../assets/index/icon_white copy.png" alt="" class="search_img1" @click="goBack">
            <input type="text" class="search_key" placeholder="请输入关键字搜索" v-model="searchkey" />
            <span class="search_btn" @click="startSearch">查询</span>
            <img src="../../../../assets/image/search.png" class="search_img" />
            <p>关键字：导游姓名/导游证号/导游省份证号/所属旅行社</p>
        </div>
        <div class="guide_header" v-if="headerShow === 3">
            <div class="header_input" @click="showCity">
                <p >{{title_text}}</p>
                <p class="way_cs"></p>
            </div>
            <div class="header_text" @click="goCitySerch">查询</div>
        </div>
        <div class="guide_list">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                :immediate-check="false"
                @load="onLoad"
                class="list_wrapper"
            >
                <div
                    class="list"
                    v-for="(t,index) in guideList"
                    :key="index"
                    >
                    <div class="list_item">
                        <div class="item_info1">
                            <p>
                                <span>序号：{{index+1}}</span><span></span>
                            </p>
                            <p>
                                <van-checkbox v-model="t.check" checked-color="#07c160" shape="square" @change="changebox(t,t.check)"></van-checkbox>
                            </p>
                        </div>
                        <div class="item_info">
                            <p>导游姓名：</p>
                            <p>{{t.name}}</p>
                        </div>
                        <div class="item_info">
                            <p>导游证号：</p>
                            <p>{{t.qualification}}</p>
                        </div>
                        <div class="item_info">
                            <p>联系电话：</p>
                            <p>{{t.phone}}</p>
                        </div>
                        <div class="item_info">
                            <p>导游星级：</p>
                            <p>{{t.guideLevelStr}}</p>
                        </div>
                        <div class="item_info">
                            <p>导游职业技术等级：</p>
                            <p>{{t.guideTypeStr}}</p>
                        </div>
                        <div class="item_info">
                            <p>所属旅行社：</p>
                            <p>{{t.travelName}}</p>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <div class="guide_buttom" v-show="btnShow">
            <div class="guide_btn" @click="addInfo">绑定导游</div>
        </div>
        <isNoInfo :isNolist="isNolist" class="isNoInfo"></isNoInfo>
        <common-picker ref="commonPicker1" :typeList="typeList1" :cols="cols1" @getTypeValue="getCityValue"></common-picker>

    </div>
</template>
<script>
    import api from '../../../../service/modules/complaint';
    import commonPicker from '../../../../components/base/commonPicker';
    import { timeType } from '../../../../utils/configJson';
    import isNoInfo from '../../../../components/isNoInfo.vue';
    import util from '@/utils/common'
    export default {
        components: {
            commonPicker,
            isNoInfo
        },
        data () {
            return {
                loading: true,
                finished: false,
                finishedText: '没有更多',
                pageIndex: '0',
                guideList: [],
                btnShow: false,
                headerShow: 1,
                checked: true,
                cityList: [],
                typeList1: timeType,
                cols1: 2,
                title_text: '选择区域',
                areaId: '',
                searchkey: '', // 搜索的ke值
                headerShow1: 0,
                isNolist: false,
                bindingIdArray: [],
                bindingNameArray: [],
                item: util.getJsonLocal('item')

            }
        },
        mounted () {
            this.getAllCity();
            this.getMoreList();
            // this.item = this.$route.query.item;
            // console.log('item', this.item)
            this.$nextTick(() => {
                document.addEventListener('click', this.hide);
            })
        },
        methods: {
            showSerch () {
                this.headerShow = 0;
                this.headerShow1 = 2;
            },
            goBack () {
                this.headerShow = 1;
                this.headerShow1 = 5;
                this.pageIndex = 0;
                this.searchkey = '';
                this.guideList = [];
                this.getMore();
            },
            btnClick () {
                this.headerShow = 3;
                console.log('btn', this.headerShow)
            },
            startSearch () {
                this.pageIndex = 0;
                this.areaId = '';
                this.getMoreList();
            },
            hide (e) {
                if (e.target.className === 'item_info') {
                    this.headerShow = 1;
                }
            },
            getCityValue (value) {
                console.log(66, value);
                if (value.length > 1) {
                    this.title_text = value[0].label + '-' + value[1].label;
                    this.areaId = value[1].areaId;
                } else {
                    this.title_text = value[0].label;
                    this.areaId = value[0].areaId;
                }
                this.getMoreList();
            },
            showCity () {
                this.$refs.commonPicker1.showPicker();
            },
            goCitySerch () {
                this.headerShow = 1;
                this.pageIndex = 0;
                this.areaId = '';
                this.getMore();
            },
            getAllCity () { // 获取所有的市
                api.mapList({ userid: '' }).then(res => {
                    const address = res.data.list;
                    var city = [
                        { 'value': '',
                          'label': '云南省',
                          'children': [
                              { 'areaId': '34',
                                'label': '全部',
                                'children': [] }
                          ] }
                    ];
                    if (address[0].F_TX_TYPE === '2' && address[0].allName !== '--') {
                        // 省级权限
                        for (var i = 0; i < address.length; i++) {
                            this.cols1 = 2;
                            var obj = {
                                areaId: address[i].areaId,
                                value: address[i].code,
                                label: address[i].allName,
                                children: []
                            };
                            if (address[i].children) {
                                address[i].children.map((item, index) => {
                                    obj.children.push({
                                        areaId: item.areaId,
                                        value: item.code,
                                        label: item.allName,
                                        children: []
                                    });
                                });
                            }
                            city.push(obj);
                        }
                    } else if (address[0].F_TX_TYPE === '3' && address.length !== 1) {
                        // 市级权限
                        this.cols1 = 2;
                        for (var i = 0; i < address.length; i++) {
                            var obj = {
                                areaId: address[i].areaId,
                                value: address[i].code,
                                label: address[i].allName,
                                children: []
                            };
                            if (address[i].children) {
                                address[i].children.map((item, index) => {
                                    obj.children.push({
                                        areaId: item.areaId,
                                        value: item.code,
                                        label: item.allName,
                                        children: []
                                    });
                                });
                            }
                            city[0].children.push(obj);
                        };
                    } else {
                        // 区县角色n
                        this.cols1 = 1;
                        var obj = {
                            areaId: address[0].areaId,
                            value: address[0].code,
                            label: address[0].allName,
                            children: []
                        };
                        city = [];
                        city.push(obj);
                    }
                    this.typeList1 = [];
                    this.typeList1.push(city);
                    setTimeout(() => {
                        this.$refs.commonPicker1._initFresh();
                    }, 50);
                });
            },
            getMoreList () {
                this.pageIndex = 1;
                this.guideList = [];
                api
                    .guideAndTravelList({
                        curPage: this.pageIndex,
                        type: 'guideList',
                        pageSize: 10,
                        cityId: '',
                        queryPar: this.searchkey
                    })
                    .then(res => {
                        this.loading = false; // 加载参数
                        if (res.data.list.length > 0) { // 有数据
                            this.guideList = res.data.list;
                            this.btnShow = true;
                            if (res.data.list.length === res.data.total) { // 已加载完了
                                this.finished = true;
                                this.loading = false;
                            } else {
                                this.finished = false;
                                this.loading = false;
                            }
                            this.isNolist = false;
                        } else {
                            this.guideList = [];
                            this.btnShow = false;
                            this.finished = true;
                            this.loading = false;
                            this.isNolist = true;
                            this.finishedText = '';
                        }
                    });
            },
            getMore () {
                this.pageIndex++;
                api
                    .guideAndTravelList({
                        curPage: this.pageIndex,
                        type: 'guideList',
                        pageSize: 10,
                        cityId: this.areaId
                    })
                    .then(res => {
                        setTimeout(() => {
                            if (res.data.list.length > 0) {
                                this.guideList = this.guideList.concat(res.data.list);
                                this.finished = false;
                                this.loading = false;
                            } else {
                                this.finished = true;
                                this.loading = false;
                            }
                        }, 500);
                    });
            },
            onLoad () {
                this.getMore();
            },
            changebox (value, type) {
                this.bindingIdArray.push(value.id);
                this.bindingNameArray.push(value.name)
                if (type === true) {
                    let newArr = [];
                    let newArr1 = [];
                    this.bindingIdArray = this.bindingIdArray.sort(function (a, b) {
                        return a > b
                    }).forEach(function (n) {
                        if (newArr.indexOf(n) === -1) {
                            newArr.push(n)
                        }
                    })
                    this.bindingIdArray = newArr;
                    this.bindingNameArray = this.bindingNameArray.sort(function (a, b) {
                        return a > b
                    }).forEach(function (n) {
                        if (newArr1.indexOf(n) === -1) {
                            newArr1.push(n)
                        }
                    })
                    this.bindingNameArray = newArr1;
                } else {
                    const number = this.bindingIdArray.indexOf(value.id);
                    if (number > -1) {
                        this.bindingIdArray.splice(number, 1);
                    }
                    const number1 = this.bindingNameArray.indexOf(value.name);
                    if (number > -1) {
                        this.bindingNameArray.splice(number1, 1);
                    }
                }
                console.log('sort', this.bindingIdArray)

                console.log('bindingIdArray', this.bindingIdArray)
            },
            addInfo () {
                api
                    .guideAndTravelOperation({
                        type: 'link',
                        main_complain_number: this.item.main_complain_number,
                        complain_number: this.item.complain_number,
                        sub_id: this.item.sub_id,
                        objType: 'guide',
                        bindingIdArray: this.bindingIdArray,
                        bindingNameArray: this.bindingNameArray
                    })
                    .then(res => {
                        // this.$router.push({
                        //     path: '/complaint/detailList/complaintSheet',
                        //     query: { item: this.item, type: 'boundList' }
                        // })
                        this.$router.back();
                    });
            }
        }
    }
</script>
<style lang="less" scoped>
.guide {
    background: #fbfbfb;
    height: 100%;
    .guide_header {
        width: 100%;
        height: 50px;
        background: #fff;
        position: fixed;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        z-index: 90;
        p>img {
            width: 20px;
            height: 20px;
        }
        p:nth-child(2) {
            font-size: 20px;
        }

        .header_input {
            display: flex;
            justify-content: space-between;
            width: 88%;
            align-items: center;
            .way_cs {
                width: 0px;
                height: 0px;
                border: 5px solid transparent;
                border-top: 7px solid #36B374;
            }
            p {
                font-size: 18px;
                color: #999999;
            }
        }
        .header_text {
            font-size: 18px;
            color:#36B374;
        }
    }
    .search {
        width: 100%;
        position: fixed;
        top: 0px;
        background: #fff;
        padding: 10px 0px;
        p {
            text-align: center;
        }
        .search_key {
            width: 275px;
            height: 36px;
            background: #f8f8f8;
            border-radius: 18px;
            margin-left: 40px;
            font-size: 13px !important;
            padding-left: 39px;
            box-sizing: border-box;
            border: 0;
            outline: none;
            line-height: 36px;
        }
        .search_btn {
            font-size: 14px;
            margin-left: 16px;
        }
        .search_img {
            width: 15px;
            height: 14px;
            position: absolute;
            left: 50px;
            top: 21px;
        }
        .search_img1 {
            width: 15px;
            height: 14px;
            position: absolute;
            left: 15px;
            top: 21px;
        }
    }
    .guide_list {
        margin-top: 50px;
        margin-bottom: 60px;
        .list_wrapper {

        }
        .list {
            width: 100%;
            padding-top: 10px;
            .list_item {
                margin: 20px 15px 0 15px;
                box-sizing: border-box;
                background-color: #fff;
                padding: 16px;
                box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
                .item_info {
                    display: flex;
                    font-size: 14px;
                    p {
                        padding: 5px 0px;
                    }
                }
                .item_info1 {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    p {
                        padding: 5px 0px;
                    }
                    p:nth-child(2) {
                        .van-checkbox {
                            .van-checkbox__icon .van-checkbox__icon--square {
                                font-size: 0px;
                            }
                        }
                    }
                }
            }
        }
    }
    .guide_buttom {
        width: 100%;
        height: 50px;
        background: #fff;
        position: fixed;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .guide_btn {
            background: #36B374;
            color: #fff;
            font-size: 14px;
            height: 40px;
            width: 93%;
            border-radius: 5px;
            text-align: center;
            line-height: 40px;
        }
    }
    .isNoInfo {
        padding-top: 100px;
    }
}
</style>
